import { useStaticQuery, graphql } from "gatsby"

export const useStories = (locale) => {
  let { allCosmicjsStories } = useStaticQuery(graphql`
    query {
      allCosmicjsStories {
        edges {
          node {
            slug
            id
            title
            locale
            metadata {
              story_personal_photo {
                imgix_url
              }
              story_quote
            }
          }
        }
      }
    }
  `)
  return allCosmicjsStories.edges
    .filter((story) => story.node.locale === "en-US")
    .map((story, index) => ({
      key: index,
      slug: story.node.slug,
      id: story.node.id,
      title: story.node.title,
      story_personal_photo: story.node.metadata.story_personal_photo?.imgix_url,
      //   story_quote: story.node.metadata.story_quote,
      //   story_body_html: story.node.metadata.story_body_html,
      //   story_link: story.node.metadata.story_link,
      //   story_image_src: story.node.metadata.story_image_src?.imgix_url,
    }))
}
